var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isDevEnv
        ? _c(
            "div",
            { staticStyle: { "margin-bottom": "16px" } },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "outline-primary",
                    disabled: _vm.disabledFields
                  },
                  on: { click: _vm.fillTestData }
                },
                [_vm._v("Preencher dados de teste")]
              )
            ],
            1
          )
        : _vm._e(),
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_01")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "A) " + _vm.$t("incident_form_responsible_email"),
            "label-for": "incident_form_responsible_email"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_responsible_email"),
              rules: "required|email"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-input", {
                      staticClass: "required",
                      attrs: {
                        id: "incident_form_responsible_email",
                        state: errors.length > 0 ? false : null,
                        name: "responsibleEmail",
                        disabled: _vm.disabledFields,
                        type: "email"
                      },
                      model: {
                        value: _vm.responsibleEmail,
                        callback: function($$v) {
                          _vm.responsibleEmail = $$v
                        },
                        expression: "responsibleEmail"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "B) " + _vm.$t("incident_form_group"),
            "label-for": "incidentGroupListSelected"
          }
        },
        [
          _c("validation-provider", {
            attrs: { name: _vm.$t("incident_form_group"), rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-checkbox-group", {
                      attrs: {
                        options: _vm.incidentGroupList,
                        "value-field": "id",
                        "text-field": "name",
                        name: "incidentGroupListSelected",
                        disabled: _vm.disabledFields,
                        stacked: ""
                      },
                      model: {
                        value: _vm.incidentGroupListSelected,
                        callback: function($$v) {
                          _vm.incidentGroupListSelected = $$v
                        },
                        expression: "incidentGroupListSelected"
                      }
                    }),
                    _vm.enableIncidentGroupOther
                      ? _c("b-form-input", {
                          staticClass: "mt-1",
                          attrs: {
                            id: "otherGroup",
                            state: errors.length > 0 ? false : null,
                            name: "otherGroup",
                            disabled: _vm.disabledFields
                          },
                          model: {
                            value: _vm.otherGroup,
                            callback: function($$v) {
                              _vm.otherGroup = $$v
                            },
                            expression: "otherGroup"
                          }
                        })
                      : _vm._e(),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "C) " + _vm.$t("incident_form_authority_identification"),
            "label-for": "incident_form_authority_identification"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_authority_identification"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "v-select",
                      {
                        staticClass: "required-select",
                        attrs: {
                          options: _vm.listLegal,
                          label: "name",
                          disabled: _vm.disabledFields
                        },
                        model: {
                          value: _vm.legalEntity,
                          callback: function($$v) {
                            _vm.legalEntity = $$v
                          },
                          expression: "legalEntity"
                        }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "no-options" }, slot: "no-options" },
                          [_vm._v(_vm._s(_vm.$t("msg_none")))]
                        )
                      ]
                    ),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "D) " +
              _vm.$t("incident_form_operator_identification") +
              " (" +
              _vm.$t("when_applicable") +
              ")",
            "label-for": "incident_form_operator_identification"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_operator_identification"),
              rules: "max:256"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-input", {
                      ref: "operatorIdentificationInput",
                      attrs: {
                        id: "operator_identification",
                        state: errors.length > 0 ? false : null,
                        disabled: _vm.disabledFields,
                        name: "operatorIdentification"
                      },
                      model: {
                        value: _vm.operatorIdentification,
                        callback: function($$v) {
                          _vm.operatorIdentification = $$v
                        },
                        expression: "operatorIdentification"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "E) " + _vm.$t("incident_form_data_authority_description"),
            "label-for": "incident_form_data_authority_description"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_data_authority_description"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "data_authority_description",
                        state: errors.length > 0 ? false : null,
                        name: "dataAuthorityDescription",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.dataAuthorityDescription,
                        callback: function($$v) {
                          _vm.dataAuthorityDescription = $$v
                        },
                        expression: "dataAuthorityDescription"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "F) " +
              _vm.$t("incident_form_who_reported") +
              _vm.$t("incident_form_name_tel_email"),
            "label-for": "incident_form_who_reported"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_who_reported"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "incident_form_who_reported",
                        state: errors.length > 0 ? false : null,
                        name: "whoReported",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.whoReported,
                        callback: function($$v) {
                          _vm.whoReported = $$v
                        },
                        expression: "whoReported"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "G) " +
              _vm.$t("incident_form_responsible_unit") +
              _vm.$t("incident_form_name_tel_email"),
            "label-for": "incident_form_responsible_unit"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_responsible_unit"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "incident_form_responsible_unit",
                        state: errors.length > 0 ? false : null,
                        name: "responsibleUnit",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.responsibleUnit,
                        callback: function($$v) {
                          _vm.responsibleUnit = $$v
                        },
                        expression: "responsibleUnit"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_02")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "A) " +
              _vm.$t("incident_form_description_incident") +
              " (" +
              _vm.$t("incident_form_root_cause") +
              ")",
            "label-for": "incident_form_description_incident"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_description_incident"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "description_incident",
                        state: errors.length > 0 ? false : null,
                        name: "descriptionIncident",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.descriptionIncident,
                        callback: function($$v) {
                          _vm.descriptionIncident = $$v
                        },
                        expression: "descriptionIncident"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "B) " + _vm.$t("incident_form_affected"),
            "label-for": "incidentAcidPropertyListSelected"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_affected"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-checkbox-group", {
                      staticClass: "mb-2",
                      attrs: {
                        options: _vm.incidentAcidPropertyList,
                        "value-field": "id",
                        "text-field": "name",
                        name: "incidentAcidPropertyListSelected",
                        stacked: "",
                        disabled: _vm.disabledFields
                      },
                      model: {
                        value: _vm.incidentAcidPropertyListSelected,
                        callback: function($$v) {
                          _vm.incidentAcidPropertyListSelected = $$v
                        },
                        expression: "incidentAcidPropertyListSelected"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "C) " +
              _vm.$t("incident_form_structure_organization_description"),
            "label-for": "incident_form_structure_organization_description"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_structure_organization_description"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "structure_organization_description",
                        state: errors.length > 0 ? false : null,
                        name: "structureOrganizationDescription",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.structureOrganizationDescription,
                        callback: function($$v) {
                          _vm.structureOrganizationDescription = $$v
                        },
                        expression: "structureOrganizationDescription"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "D) " + _vm.$t("incident_form_how_identified"),
            "label-for": "incident_form_how_identified"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_how_identified"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "incident_form_how_identified",
                        state: errors.length > 0 ? false : null,
                        name: "howIdentified",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.howIdentified,
                        callback: function($$v) {
                          _vm.howIdentified = $$v
                        },
                        expression: "howIdentified"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "E) " +
              _vm.$t("incident_form_holders_report") +
              " " +
              _vm.$t("incident_form_case_yes_contact"),
            "label-for": "incident_form_holders_report"
          }
        },
        [
          _c("validation-provider", {
            attrs: { name: _vm.$t("incident_form_holders_report") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-input", {
                      attrs: {
                        id: "incident_form_holders_report",
                        state: errors.length > 0 ? false : null,
                        disabled: _vm.disabledFields,
                        name: "holdersReport"
                      },
                      model: {
                        value: _vm.holdersReport,
                        callback: function($$v) {
                          _vm.holdersReport = $$v
                        },
                        expression: "holdersReport"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "F) " + _vm.$t("incident_form_anpd_report_incident"),
            "label-for": "incident_form_anpd_report_incident"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_anpd_report_incident"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "incident_form_anpd_report_incident",
                        state: errors.length > 0 ? false : null,
                        name: "anpdReportIncident",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.anpdReportIncident,
                        callback: function($$v) {
                          _vm.anpdReportIncident = $$v
                        },
                        expression: "anpdReportIncident"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_03")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "A) " + _vm.$t("incident_form_leaked_content"),
            "label-for": "incidentLeakedContentListSelected"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_leaked_content"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-checkbox-group", {
                      staticClass: "mb-2",
                      attrs: {
                        options: _vm.incidentLeakedContentList,
                        "value-field": "id",
                        "text-field": "name",
                        name: "incidentLeakedContentListSelected",
                        stacked: "",
                        disabled: _vm.disabledFields
                      },
                      model: {
                        value: _vm.incidentLeakedContentListSelected,
                        callback: function($$v) {
                          _vm.incidentLeakedContentListSelected = $$v
                        },
                        expression: "incidentLeakedContentListSelected"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "B) " + _vm.$t("category_personal_data"),
            "label-for": "category_personal_data"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("category_personal_data"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "category_personal_data",
                        state: errors.length > 0 ? false : null,
                        name: "categoryPersonalData",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.categoryPersonalData,
                        callback: function($$v) {
                          _vm.categoryPersonalData = $$v
                        },
                        expression: "categoryPersonalData"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "C) " + _vm.$t("incident_form_data_old_or_new"),
            "label-for": "incident_form_data_old_or_new"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_data_old_or_new"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "data_old_or_new",
                        state: errors.length > 0 ? false : null,
                        name: "dataOldOrNew",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.dataOldOrNew,
                        callback: function($$v) {
                          _vm.dataOldOrNew = $$v
                        },
                        expression: "dataOldOrNew"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "D) " + _vm.$t("number_affected_holders"),
            "label-for": "number_affected_holders"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("number_affected_holders"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-input", {
                      ref: "number_affected_holdersInput",
                      staticClass: "required",
                      attrs: {
                        id: "number_affected_holders",
                        state: errors.length > 0 ? false : null,
                        type: "number",
                        name: "number_affected_holders",
                        disabled: _vm.disabledFields
                      },
                      on: { keyup: _vm.validateNumberAffectedHolders },
                      model: {
                        value: _vm.numberAffectedHolders,
                        callback: function($$v) {
                          _vm.numberAffectedHolders = $$v
                        },
                        expression: "numberAffectedHolders"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "E) " +
              _vm.$t("incident_form_total_affected_holders") +
              " (" +
              _vm.$t("incident_form_total_affected_holders_01") +
              ")",
            "label-for": "incident_form_total_affected_holders"
          }
        },
        [
          _c("validation-provider", {
            attrs: { name: _vm.$t("incident_form_total_affected_holders") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-input", {
                      attrs: {
                        id: "total_affected_holders",
                        state: errors.length > 0 ? false : null,
                        disabled: _vm.disabledFields,
                        name: "totalAffectedHolders"
                      },
                      model: {
                        value: _vm.totalAffectedHolders,
                        callback: function($$v) {
                          _vm.totalAffectedHolders = $$v
                        },
                        expression: "totalAffectedHolders"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_04")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "A) " + _vm.$t("incident_form_date_incident"),
            "label-for": "incident_form_date_incident"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_date_incident"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("flat-pickr", {
                      staticClass: "form-control required",
                      class: { "is-disabled": _vm.disabledFields },
                      attrs: {
                        config: _vm.configCalendar,
                        disabled: _vm.disabledFields
                      },
                      model: {
                        value: _vm.incidentDate,
                        callback: function($$v) {
                          _vm.incidentDate = $$v
                        },
                        expression: "incidentDate"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "B) " + _vm.$t("incident_form_date_authority"),
            "label-for": "incident_form_date_authority"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_date_authority"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("flat-pickr", {
                      staticClass: "form-control required",
                      class: { "is-disabled": _vm.disabledFields },
                      attrs: {
                        config: _vm.configCalendar,
                        disabled: _vm.disabledFields
                      },
                      model: {
                        value: _vm.dateAuthority,
                        callback: function($$v) {
                          _vm.dateAuthority = $$v
                        },
                        expression: "dateAuthority"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "C) " + _vm.$t("incident_form_reasons_delay"),
            "label-for": "incident_form_reasons_delay"
          }
        },
        [
          _c("validation-provider", {
            attrs: { name: _vm.$t("incident_form_reasons_delay") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      attrs: {
                        id: "reasons_delay",
                        state: errors.length > 0 ? false : null,
                        disabled: _vm.disabledFields,
                        name: "reasonsDelay",
                        rows: "4"
                      },
                      model: {
                        value: _vm.reasonsDelay,
                        callback: function($$v) {
                          _vm.reasonsDelay = $$v
                        },
                        expression: "reasonsDelay"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_05")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "A) " +
              _vm.$t("incident_form_data_protection_measures") +
              " (" +
              _vm.$t("incident_form_data_protection_measures_01") +
              ")",
            "label-for": "incident_form_data_protection_measures"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_data_protection_measures"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "data_protection_measures",
                        state: errors.length > 0 ? false : null,
                        name: "dataProtectionMeasures",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.dataProtectionMeasures,
                        callback: function($$v) {
                          _vm.dataProtectionMeasures = $$v
                        },
                        expression: "dataProtectionMeasures"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "B) " + _vm.$t("incident_form_actions_reverse_incident"),
            "label-for": "incident_form_actions_reverse_incident"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_actions_reverse_incident"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "actions_reverse_incident",
                        state: errors.length > 0 ? false : null,
                        name: "actionsReverseIncident",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.actionsReverseIncident,
                        callback: function($$v) {
                          _vm.actionsReverseIncident = $$v
                        },
                        expression: "actionsReverseIncident"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "C) " +
              _vm.$t("incident_form_other_description") +
              " (" +
              _vm.$t("incident_form_other_description_01") +
              ")",
            "label-for": "incident_form_other_description"
          }
        },
        [
          _c("validation-provider", {
            attrs: { name: _vm.$t("incident_form_other_description") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      attrs: {
                        id: "incident_form_other_description",
                        state: errors.length > 0 ? false : null,
                        disabled: _vm.disabledFields,
                        name: "otherDescription",
                        rows: "4"
                      },
                      model: {
                        value: _vm.otherDescription,
                        callback: function($$v) {
                          _vm.otherDescription = $$v
                        },
                        expression: "otherDescription"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_06")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "A) " + _vm.$t("incident_form_related_risks"),
            "label-for": "incident_form_related_risks"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_related_risks"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "related_risks",
                        state: errors.length > 0 ? false : null,
                        name: "relatedRisks",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.relatedRisks,
                        callback: function($$v) {
                          _vm.relatedRisks = $$v
                        },
                        expression: "relatedRisks"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "B) " + _vm.$t("incident_form_comunication_content"),
            "label-for": "incident_form_comunication_content"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_comunication_content"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "comunication_content",
                        state: errors.length > 0 ? false : null,
                        name: "comunicationContent",
                        disabled: _vm.disabledFields,
                        rows: "4"
                      },
                      model: {
                        value: _vm.comunicationContent,
                        callback: function($$v) {
                          _vm.comunicationContent = $$v
                        },
                        expression: "comunicationContent"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "C) " + _vm.$t("incident_form_communication_content_attachments"),
            "label-for": "incident_form_communication_content_attachments"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_communication_content_attachments")
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-file", {
                      attrs: {
                        id: "communication_content_attachments",
                        placeholder:
                          "Clique para selecionar os arquivos ou arraste aqui...",
                        "drop-placeholder": "Solte os arquivos aqui...",
                        state: errors.length > 0 ? false : null,
                        name: "communicationContentAttachments",
                        disabled: _vm.disabledFields,
                        multiple: "",
                        accept: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                      },
                      on: { input: _vm.appendCommunicationContentAttachments },
                      model: {
                        value: _vm.newCommunicationContentAttachments,
                        callback: function($$v) {
                          _vm.newCommunicationContentAttachments = $$v
                        },
                        expression: "newCommunicationContentAttachments"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ]),
                    _c("small", { staticClass: "form-text text-muted" }, [
                      _c("i", { staticClass: "feather icon-upload mr-1" }),
                      _vm._v(
                        " Selecione um ou mais arquivos para anexar. Todos os anexos são opcionais. "
                      )
                    ]),
                    _vm.communicationContentAttachments &&
                    _vm.communicationContentAttachments.length
                      ? _c(
                          "div",
                          { staticClass: "mt-2" },
                          [
                            _c(
                              "b-list-group",
                              _vm._l(
                                _vm.communicationContentAttachments,
                                function(file, idx) {
                                  return _c(
                                    "b-list-group-item",
                                    {
                                      key:
                                        _vm.getAttachmentName(file) + "-" + idx,
                                      staticClass:
                                        "d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _c("div", [
                                        _c("i", {
                                          staticClass:
                                            "feather icon-file-text text-primary mr-2"
                                        }),
                                        _vm.getAttachmentUrl(file)
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "mr-2 download-link text-primary",
                                                attrs: {
                                                  href: _vm.getAttachmentUrl(
                                                    file
                                                  ),
                                                  target: "_blank",
                                                  title: "Baixar arquivo"
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-download"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.getAttachmentName(file))
                                          )
                                        ]),
                                        _vm.getAttachmentSize(file)
                                          ? _c(
                                              "small",
                                              {
                                                staticClass: "ml-2 text-muted"
                                              },
                                              [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(
                                                      _vm.formatAttachmentSize(
                                                        _vm.getAttachmentSize(
                                                          file
                                                        )
                                                      )
                                                    ) +
                                                    ")"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      !_vm.disabledFields
                                        ? _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                variant: "outline-danger",
                                                size: "sm"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeAttachment(
                                                    idx
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "feather icon-trash-2"
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "D) " + _vm.$t("incident_form_anpd_communicated"),
            "label-for": "incident_form_anpd_communicated"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_anpd_communicated"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-radio-group", {
                      staticClass: "required",
                      attrs: {
                        id: "incident_form_anpd_communicated",
                        state: errors.length > 0 ? false : null,
                        name: "anpdCommunicated",
                        options: _vm.anpdCommunicatedList,
                        disabled: _vm.disabledFields,
                        stacked: ""
                      },
                      model: {
                        value: _vm.anpdCommunicated,
                        callback: function($$v) {
                          _vm.anpdCommunicated = $$v
                        },
                        expression: "anpdCommunicated"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "E) " + _vm.$t("incident_form_reasons_lack_communication"),
            "label-for": "incident_form_reasons_lack_communication"
          }
        },
        [
          _c("validation-provider", {
            attrs: {
              name: _vm.$t("incident_form_reasons_lack_communication"),
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("b-form-textarea", {
                      staticClass: "required",
                      attrs: {
                        id: "reasons_lack_communication",
                        state: errors.length > 0 ? false : null,
                        name: "reasonsLackCommunication",
                        rows: "4",
                        disabled: _vm.disabledFields
                      },
                      model: {
                        value: _vm.reasonsLackCommunication,
                        callback: function($$v) {
                          _vm.reasonsLackCommunication = $$v
                        },
                        expression: "reasonsLackCommunication"
                      }
                    }),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }